const splitterRootContextKey = Symbol("splitterRootContextKey");

export { splitterRootContextKey };
//# sourceMappingURL=type.mjs.map
